import React, { Component } from 'react';
import { ScrollSyncPane } from 'react-scroll-sync'
import { push } from 'react-router-redux'
import { NavLink } from 'react-router-dom'
import '../stylesheets/inventory.sass'
import _ from 'lodash'
import moment from 'moment'

export default class AccountingRow extends Component {

  kegSizeLabels = () => {
    return {
      'mini_keg': 'Mini Keg',
      'cornelius_keg': 'Cornelius Keg',
      'sixth_barrel': '1/6th Barrel',
      'quarter_barrel': 'Quarter Barrel',
      'slim_quarter': 'Slim Quarter',
      'half_barrel': '1/2 Barrel',
      'rubber_barrel': 'Rubber Barrel',
      'beveled_barrel': 'Beveled Barrel',
      'fifty_liter': '50 Liter',
      'thirty_liter': '30 Liter'
    }
  }

  render() {
    return(
      <div className='customer_row'>
        <NavLink to={`/reservations/${this.props.accounting && this.props.accounting.attributes && this.props.accounting.attributes.orderId}`}>
        { this.props.accounting &&
          this.props.accounting['attributes'] &&
        <div className='customer_row_wrapper'>
          <div className='customer_col_one'>
          </div>
          <div className='column-one customer-col name'>
            <div>
              { this.props.accounting['attributes']['nameOnCharge']}
            </div>
          </div>
          <ScrollSyncPane>
            <div className='scroll'>
              <div className='customer-col half'>
                <div>
                  { moment(this.props.accounting['attributes']['chargedAt']).format('MM/DD/YYYY')}
                </div>
              </div>
              <div className='customer-col quarter-slim'>
                <div>
                  {
                    this.props.accounting['attributes']['prices']
                      && this.props.accounting['attributes']['prices']['totalPrice']
                  }
                </div>
              </div>
              <div className='customer-col quarter-slim'>
                <div>
                  { this.props.accounting['attributes']['prices'] && this.props.accounting['attributes']['prices']['tax'] }
                </div>
              </div>
              <div className='customer-col quarter' style={{'flexDirection': 'column', 'alignItems': 'start'}}>
                  {
                    this.props.accounting['attributes']['productNamesAndPrices'] && this.props.accounting['attributes']['productNamesAndPrices'].map((productNameAndPrice, index) => {
                      return(
                        <div style={{ fontSize: '10px' }}>
                          { (index + 1) + '. ' + productNameAndPrice['name'] + ' ' + this.kegSizeLabels()[productNameAndPrice['size']]  }
                        </div>
                      )
                    })
                  }
              </div>
              <div className='customer-col quarter'>
                <div>
                  { this.props.accounting['attributes']['last4']}
                </div>
              </div>
              <div className='customer_col_last customer-col sixth'>
                <div>
                  { this.props.accounting['attributes']['status'] && _.startCase(this.props.accounting['attributes']['status']) }
                </div>
              </div>
            </div>
          </ScrollSyncPane>
        </div>
        }
      </NavLink>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Accounting/Row.jsx